<template>
  <div style="height: 100%" id="page-top">
    <div style="width: 0; height: 0">
      <editor
        style="height: 600px"
        api-key="delvvnyj19p3766fx0v03i17fft7ljxhq29ccccyxs2nnxor"
      />
    </div>
    <div style="height: 100%" id="wrapper">
      <nav
        class="navbar navbar-dark align-items-start sidebar sidebar-dark accordion bg-gradient-primary p-0"
      >
        <div class="container-fluid d-flex flex-column p-0">
          <a
            class="navbar-brand d-flex justify-content-center align-items-center sidebar-brand m-0"
          >
            <div class="sidebar-brand-icon rotate-n-15">
              <i class="fas fa-laugh-wink"></i>
            </div>
            <div class="sidebar-brand-text mx-3"><span>Motinova</span></div>
          </a>
          <hr class="sidebar-divider my-0" />
          <ul class="navbar-nav text-light" id="accordionSidebar">
            <li class="nav-item" v-if="role.updateProduct || role.updateProductCatlog">
              <a
                @click="MenuClick('ProductCatlog')"
                :class="ActiveTabClass('ProductCatlog')"
                ><i class="fas fa-table"></i><span>{{ $t("productmanage") }}</span></a
              >
            </li>
            <li class="nav-item">
              <a
                @click="MenuClick('productCatlogBroswer')"
                :class="ActiveTabClass('productCatlogBroswer')"
                ><i class="fa fa-search"></i><span>{{ $t("productbrowsing") }}</span></a
              >
            </li>
            <!-- <li class="nav-item">
              <a
                @click="MenuClick('ProductCodeGen')"
                :class="ActiveTabClass('ProductCodeGen')"
                ><i class="fa fa-barcode"></i><span>产品编码</span></a
              >
            </li> -->
            <li class="nav-item">
              <a @click="MenuClick('Progress')" :class="ActiveTabClass('Progress')"
                ><i class="fa fa-battery-three-quarters"></i
                ><span>{{ $t("projectprogress") }}</span></a
              >
            </li>

            <li class="nav-item">
              <a @click="MenuClick('Measure')" :class="ActiveTabClass('Measure')"
                ><i class="fa fa-briefcase"></i><span>{{ $t("faultmeasure") }}</span></a
              >
            </li>

            <li class="nav-item">
              <a
                @click="MenuClick('DownloadMenu')"
                :class="ActiveTabClass('DownloadMenu')"
                ><i class="fa fa-file"></i><span>{{ $t("filedown") }}</span></a
              >
            </li>

            <li
              class="nav-item"
              v-if="role.updateProduct || role.updateProductCatlog || role.changePrice"
            >
              <a @click="MenuClick('MyApprove')" :class="ActiveTabClass('MyApprove')"
                ><i class="fa fa-check-circle-o"></i><span>{{ $t("myapprove") }}</span></a
              >
            </li>

            <li class="nav-item" v-if="role.showAuditMenu">
              <a @click="MenuClick('Approve')" :class="ActiveTabClass('Approve')"
                ><i class="fa fa-check"></i><span>{{ $t("approve") }}</span></a
              >
            </li>

            <li class="nav-item">
              <a @click="OrderClick" :class="ActiveTabClass('none')"
                ><i class="fa fa-table"></i><span>订单管理系统</span></a
              >
            </li>

            <!-- <li class="nav-item">
                <a @click="MenuClick('Dashboard')" :class="ActiveTabClass('Dashboard')"><i
                    class="fas fa-tachometer-alt"></i><span>{{ $t("operatelog") }}</span></a>

            </li> -->
            <li class="nav-item">
              <a @click="MenuClick('Log')" :class="ActiveTabClass('Log')"
                ><i class="fa fa-file-text-o"></i><span>{{ $t("operatelog") }}</span></a
              >
            </li>
            <!-- <li class="nav-item">
              <a @click="MenuClick('UpdateLog')" :class="ActiveTabClass('UpdateLog')"
                ><i class="fa fa-rocket"></i><span>{{ $t("UPDATELOG") }}</span></a
              >
            </li> -->
            <!-- <li class="nav-item">
              <a @click="MenuClick('OederReview')" :class="ActiveTabClass('OederReview')"
                ><i class="fa fa-rocket"></i><span>{{ "订单评审审核表" }}</span></a
              >
            </li> -->
            <!-- <li class="nav-item">
              <a @click="MenuClick('OederReview')" :class="ActiveTabClass('OederReview')"
                ><i class="fa fa-rocket"></i><span>{{ "知识管理工具" }}</span></a
              >
            </li> -->
            <!-- <li class="nav-item">
              <a @click="MenuClick('OrderGuide')" :class="ActiveTabClass('OrderGuide')"
                ><i class="fa fa-rocket"></i><span>{{ $t("ORDERGUIDE") }}</span></a
              >
            </li> -->
            <li
              class="nav-item"
              v-if="role.showUserMenu"
              style="position: absolute; bottom: 10px"
            >
              <a @click="MenuClick('UserManage')" :class="ActiveTabClass('UserManage')"
                ><i class="far fa-user-circle"></i><span>{{ $t("usermanage") }}</span></a
              >
            </li>
          </ul>
        </div>
      </nav>

      <div class="d-flex flex-column" id="content-wrapper">
        <div id="content">
          <nav
            class="navbar navbar-light navbar-expand bg-white shadow mb-4 topbar static-top"
          >
            <div class="container-fluid">
              <button
                class="btn btn-link d-md-none rounded-circle me-3"
                id="sidebarToggleTop-1"
                type="button"
              >
                <i class="fas fa-bars"></i>
              </button>
              <span style="margin-left: 20px">
                <p style="margin: 0px 10px 0px 0px">{{ $t("title") }}</p>
              </span>
              <ul class="navbar-nav flex-nowrap ms-auto">
                <li class="nav-item dropdown no-arrow">
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      <i class="fas fa-language"></i>
                      <span style="margin-left: 10px">{{ $t("switchlang") }}</span>
                      <el-icon class="el-icon--right">
                        <arrow-down />
                      </el-icon>
                    </span>
                    <template #dropdown>
                      <el-dropdown-menu>
                        <el-dropdown-item @click="$i18n.locale = '中文'">
                          中文
                        </el-dropdown-item>
                        <el-dropdown-item @click="$i18n.locale = 'English'">
                          English
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </li>
                <li style="margin-left: 20px" class="nav-item dropdown no-arrow">
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      <i class="fas fa-user"></i>
                      <span style="margin-left: 10px">{{ $tt(realName) }}</span>
                      <el-icon class="el-icon--right">
                        <arrow-down />
                      </el-icon>
                    </span>
                    <template #dropdown>
                      <el-dropdown-menu>
                        <el-dropdown-item @click="changePassword">{{
                          $t("changepassword")
                        }}</el-dropdown-item>
                        <el-dropdown-item @click="logout">{{
                          $t("logout")
                        }}</el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </li>
              </ul>
            </div>
          </nav>

          <div class="container-fluid">
            <router-view></router-view>
          </div>
        </div>
        <footer class="bg-white sticky-footer">
          <div class="container my-auto">
            <div class="text-center my-auto copyright">
              <span>Copyright © TTIUM 2024</span>
            </div>
          </div>
        </footer>
      </div>
      <a class="border rounded d-inline scroll-to-top" @click="topclick"
        ><i class="fas fa-angle-up"></i
      ></a>
    </div>
  </div>
</template>

<script>
import router from "../router/index";
import Editor from "@tinymce/tinymce-vue";
import getRole from "../common/role";
import Swal from "sweetalert2";
import * as httphelper from "../common/httphelper";

export default {
  components: { Editor },
  data: function () {
    return {
      activeTab: "productCatlogBroswer",
      role: {},
      realName: "",
    };
  },
  methods: {

    OrderClick(){
      let user={
        id:sessionStorage.getItem('id'),
        userName:sessionStorage.getItem('mail'),
        role:sessionStorage.getItem('role'),
        realName:sessionStorage.getItem('name')
      }

      let param= window.btoa(encodeURIComponent(JSON.stringify(user)))

      window.location.href=("https://order.motinova.com/login?user="+param)
      //window.open("http://127.0.0.1:3000/login?user="+param,"_blank")
    },

    async changePassword() {
      const { value: formValues } = await Swal.fire({
        title: "修改密码",
        showCancelButton: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        html:
          '<span>输入原密码<span/><input type="password" id="swal-input1" class="swal2-input"><br/>' +
          '<span>输入新密码<span/><input type="password" id="swal-input2" class="swal2-input"><br/>' +
          '<span>确认新密码<span/><input type="password" id="swal-input3" class="swal2-input"><br/>',
        focusConfirm: false,
        preConfirm: () => {
          return {
            OldPassword: document.getElementById("swal-input1").value,
            NewPassword: document.getElementById("swal-input2").value,
            NewPasswordConfirm: document.getElementById("swal-input3").value,
          };
        },
      });

      if (formValues.NewPassword !== formValues.NewPasswordConfirm) {
        await Swal.fire({
          icon: "error",
          title: "提示",
          text: "两次输入密码输入不一致",
        });
        return;
      }

      if (formValues.OldPassword && formValues.NewPassword) {
        await httphelper.ChangePW(formValues).then((res) => {
          if (res.data.data) {
            Swal.fire({
              icon: "success",
              title: "提示",
              text: "修改成功",
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "提示",
              text: res.data.message,
            });
          }
        });
      }
    },

    logout() {
      sessionStorage.clear();
      self.location = "#";
      location.reload();
    },
    MenuClick(name) {
      this.activeTab = name;
      router.push(name);
    },
    ActiveTabClass(isActive) {
      if (
        isActive == "ProductCatlog" &&
        (this.activeTab == "ProductList" || this.activeTab == "AddProduct")
      ) {
        return "nav-link active";
      }

      if (isActive == "DownloadMenu" && this.activeTab == "CertView") {
        return "nav-link active";
      }

      if (isActive == "productCatlogBroswer" && this.activeTab == "ProductSearch") {
        return "nav-link active";
      }

      return this.activeTab == isActive ? "nav-link active" : "nav-link";
    },
    topclick() {
      scroll(0, 0);
    },
  },
  mounted() {
    this.role = getRole();
    router.afterEach((to, from) => {
      this.activeTab = to.name;
    });
    this.realName = sessionStorage.getItem("name");
  },
};
</script>

<style>

.nav-link{
  font-size: 12px !important;
}

</style>
